<script setup lang="ts">
definePageMeta({
  layout: 'front-page',
  public: true,
  pageTitle: {
    title: 'Toegankelijkheidsverklaring',
    subtitle: 'Onze inzet voor een toegankelijke website volgens WCAG 2.1 standaarden',
    icon: 'bx-accessibility',
    iconColor: 'success',
  },
})

const sections = [
  {
    title: '1. Algemeen',
    content: '\'t SpeelFabrik VZW streeft ernaar onze website toegankelijk te maken voor iedereen, inclusief mensen met een beperking. Deze toegankelijkheidsverklaring is van toepassing op www.tspeelfabrik.be.',
  },
  {
    title: '2. Stand van zaken',
    content: 'Deze website is gedeeltelijk conform met de Web Content Accessibility Guidelines (WCAG) 2.1 niveau AA. Wij werken er voortdurend aan om de toegankelijkheid te verbeteren en blijven ons inzetten voor een inclusieve digitale ervaring.',
  },
  {
    title: '3. Maatregelen die wij nemen',
    content: `'t SpeelFabrik VZW neemt de volgende maatregelen om de toegankelijkheid van onze website te waarborgen:
• Toegankelijkheid is opgenomen in onze missie
• We voeren regelmatig toegankelijkheidstests uit
• We trainen onze vrijwilligers en medewerkers in toegankelijkheid
• We stellen duidelijke toegankelijkheidsdoelen en nemen verantwoordelijkheid`,
  },
  {
    title: '4. Conformiteitsstatus',
    content: `De Web Content Accessibility Guidelines (WCAG) definiëren vereisten voor ontwerpers en ontwikkelaars om de toegankelijkheid voor mensen met beperkingen te verbeteren. Deze richtlijnen definiëren drie conformiteitsniveaus: Niveau A, Niveau AA en Niveau AAA.

Deze website is gedeeltelijk conform met WCAG 2.1 niveau AA. Gedeeltelijk conform betekent dat sommige delen van de content niet volledig voldoen aan de toegankelijkheidsstandaard.`,
  },
  {
    title: '5. Feedback',
    content: `Wij stellen uw feedback op prijs over de toegankelijkheid van onze website. Als u problemen ondervindt of verbeteringen wilt voorstellen, neem dan contact met ons op:

E-mail: contact@tspeelfabrik.be
Telefoon: +32 474 68 10 52
Postadres: Langestraat 15b, 1910 Kampenhout

We proberen binnen 5 werkdagen te reageren op uw feedback.`,
  },
  {
    title: '6. Bekende beperkingen',
    content: `Ondanks onze inspanningen kunnen sommige delen van de website toegankelijkheidsproblemen hebben:
• Oudere documenten en PDF's zijn mogelijk niet volledig toegankelijk
• Sommige externe content (zoals video's van derden) is mogelijk niet volledig toegankelijk
• Bepaalde complexe interactieve elementen zijn mogelijk beperkt toegankelijk met screenreaders

We werken aan het oplossen van deze problemen.`,
  },
  {
    title: '7. Compatibiliteit met browsers en hulptechnologieën',
    content: `Deze website is ontworpen om te werken met de volgende hulptechnologieën:
• Moderne webbrowsers (Chrome, Firefox, Safari, Edge)
• Screenreaders (JAWS, NVDA, VoiceOver)
• Toetsenbordnavigatie
• Spraakherkenningssoftware
• Schermvergrotingssoftware`,
  },
  {
    title: '8. Technische specificaties',
    content: `De toegankelijkheid van deze website is afhankelijk van de volgende technologieën:
• HTML
• CSS
• JavaScript
• ARIA (Accessible Rich Internet Applications)`,
  },
  {
    title: '9. Beoordelingsmethode',
    content: `'t SpeelFabrik VZW heeft de toegankelijkheid van deze website beoordeeld met behulp van de volgende methoden:
• Zelfevaluatie: De website is geëvalueerd door ons eigen team
• Geautomatiseerde tests: We gebruiken toegankelijkheidstools voor continue monitoring`,
  },
  {
    title: '10. Formele goedkeuring van deze verklaring',
    content: `Deze toegankelijkheidsverklaring is goedgekeurd door:
't SpeelFabrik VZW
Paeps Steven, Verantwoordelijke`,
  },
  {
    title: '11. Datum en herziening',
    content: `Deze verklaring is opgesteld op ${new Date().toLocaleDateString('nl-BE')}.
Deze verklaring werd voor het laatst herzien op ${new Date().toLocaleDateString('nl-BE')}.`,
  },
  {
    title: '12. Handhavingsprocedure',
    content: `Als u niet tevreden bent met onze reactie op uw toegankelijkheidsmelding, kunt u contact opnemen met:

Ombudsdienst (indien van toepassing)
Of
De toezichthouder voor digitale toegankelijkheid in België`,
  },
]
</script>

<template>
  <VContainer>
    <VCard
      class="pa-4 mx-auto"
      max-width="1200"
    >
      <VCardText>
        <VContainer>
          <div
            v-for="(section, index) in sections"
            :key="index"
            class="mb-6"
          >
            <h2 class="text-h6 mb-3">
              {{ section.title }}
            </h2>
            <p
              class="text-body-1"
              style="white-space: pre-line;"
            >
              {{ section.content }}
            </p>
          </div>

          <VDivider class="my-6" />

          <div class="text-center">
            <VBtn
              to="/"
              color="primary"
            >
              Terug naar Home
            </VBtn>
          </div>
        </VContainer>
      </VCardText>
    </VCard>
  </VContainer>
</template>
